/*
|-------------------------------------------------------------------------------
| VUEX modules/bookings.js
|-------------------------------------------------------------------------------
| The Vuex data store for the cafes

status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import PlaceAPI from '../api/place.js';

export const places = {
    state: {
        places: [],
        placesLoadStatus: 0,

        placeAdded: {},
        placeAddStatus: 0,

        placeUpdated: {},
        placeUpdateStatus: 0,

        placeDeleted: {},
        placeDeleteStatus: 0,
        placeDeleteText: '',
    },

    actions: {
        loadPlaces({commit}) {
            return new Promise((resolve, reject) => {
                commit('setPlacesLoadStatus', 1);

                PlaceAPI.getPlaces()
                    .then(response => {
                        commit('setPlaces', response.data.data);
                        commit('setPlacesLoadStatus', 2);
                        resolve();
                    })
                    .catch(() => {
                        commit('setPlaces', []);
                        commit('setPlacesLoadStatus', 3);
                        reject();
                    });
            });
        },
        addPlace({commit, dispatch}, data){
            return new Promise((resolve, reject) => {
                commit('setPlaceAddStatus', 1);

                PlaceAPI.postPlace( data )
                    .then(response => {
                        commit('setPlaceAdded', response.data.data);
                        commit('setPlaceAddStatus', 2);
                        dispatch('loadPlaces');
                        resolve();
                    })
                    .catch(() => {
                        commit('setPlaceAdded', []);
                        commit('setPlaceAddStatus', 3);
                        reject();
                    });
            });
        },
        updatePlace({commit, dispatch}, data){
            return new Promise((resolve, reject) => {
                commit('setPlaceUpdateStatus', 1);

                PlaceAPI.putPlace( data )
                    .then(response => {
                        commit('setPlaceUpdateStatus', 2);
                        dispatch('loadPlaces');
                        resolve();
                    })
                    .catch(() => {
                        commit('setPlaceUpdateStatus', 3);
                        reject();
                    });
            });
        },
        deletePlace({commit, dispatch}, placeId){
            return new Promise((resolve, reject) => {
                commit('setPlaceDeleteStatus', 1);

                PlaceAPI.deletePlace( placeId )
                    .then(response => {
                        commit('setPlaceDeletedText', 'success');
                        commit('setPlaceDeleteStatus', 2);
                        dispatch('loadPlaces');
                        resolve();
                    })
                    .catch(() => {
                        commit('setPlaceDeletedText', 'unsuccess');
                        commit('setPlaceDeleteStatus', 3);
                        reject();
                    });
            });
        },
    },

    mutations: {
        setPlaces( state, rawPlaces ){
            state.places = rawPlaces.map(rawPlace => {
                return {
                    id: rawPlace.id,
                    name: rawPlace.name,
                    addressReadable: rawPlace.address_readable,
                    lat: rawPlace.coordinates.coordinates[1],
                    lng: rawPlace.coordinates.coordinates[0],
                }
            });
        },
        setPlacesLoadStatus( state, status ){
            state.placesLoadStatus = status;
        },
        setPlaceAdded( state, rawPlaceAdded ){
            state.placeAdded = rawPlaceAdded;
        },
        setPlaceAddStatus( state, status ){
            state.placeAddStatus = status;
        },
        setPlaceUpdated( state, rawPlaceUpdated ){
            state.placeUpdated = rawPlaceUpdated;
        },
        setPlaceUpdateStatus( state, status ){
            state.placeUpdateStatus = status;
        },
        setPlaceDeletedText( state, text ){
            state.placeDeleteText = text;
        },
        setPlaceDeleteStatus( state, status ){
            state.placeDeletedStatus = status;
        },
    },

    getters: {
        getPlaces(state) {
            return state.places;
        },
        getPlacesLoadStatus(state) {
            return state.placesLoadStatus;
        },
        getPlaceUpdateStatus(state) {
            return state.placeUpdateStatus;
        },
        getPlaceDeleteStatus(state) {
            return state.placeDeleteStatus;
        },
        getPlaceAddStatus(state) {
            return state.placeAddStatus;
        },
    },
};

/**
 * Helpers
 */

